export type OptionType<T> = {
  label: string
  value: T
  dataTest?: string
}

export type GroupOptionType<T> = {
  label: string
  options: Array<OptionType<T>>
}

export type DropdownOptionsT<T> =
  | {
      tag: 'grouped'
      groups: Array<GroupOptionType<T>>
    }
  | {
      tag: 'flat'
      options: Array<OptionType<T>>
    }

export function groupedOptions<T>(groups: Array<GroupOptionType<T>>): DropdownOptionsT<T> {
  return {
    tag: 'grouped',
    groups,
  }
}

export function flatOptions<T>(options: Array<OptionType<T>>): DropdownOptionsT<T> {
  return {tag: 'flat', options}
}
